import React, { useEffect, useState, useRef, useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import { Player, BigPlayButton, Shortcut, ControlBar, PlaybackRateMenuButton } from 'video-react';
// import { handleFullscreenChange } from 'video-react/lib/actions/player';
import styles from './Video.module.less';
import { getVideoContent } from '../../actions/card';
import fail from '../../static/msg-fail.svg';
import '../../../node_modules/video-react/dist/video-react.css';
import { PCStoreJsBridge } from '../../nativeapi';
import { logging } from '../../actions/log';

const selectVideo = createSelector(
  state => state.card,
  card => card.video,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const Video = props => {
  const {
    onVideoError,
    imgUrl,
    videoId = 1,
    width = 640,
    height = 360,
    disableDefaultControls = true, // 是否显示播放控制栏
    source,
    loop = false,
    logInfo,
  } = props;

  const video = useSelector(selectVideo);
  const logInfoData = useSelector(selectLogInfo);
  const [player, setPlayer] = useState(null);
  const dispatch = useDispatch();
  const [fullScreen, setFullScreen] = useState(false);
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const busyRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [pause, setPause] = useState(true);

  useEffect(() => {
    if (busy) {
      setTimeout(() => {
        setBusy(false);
      }, 300);
    }
  }, [busy]);
  useEffect(() => {
    countRef.current = count;
    busyRef.current = busy;
  });
  const shortcuts = [
    {
      keyCode: 32,
      crtl: true,
      handle: (players, actions) => {
        const { paused } = players;
        if (paused) {
          actions.play();
        } else {
          actions.pause();
        }
      },
    },
    {
      keyCode: 70,
      handle: () => {},
    },
  ];

  // 根据视频的id获取视频的内容
  useEffect(() => {
    dispatch(
      getVideoContent({
        videoId,
      }),
    );
  }, [videoId]);
  // 监听视频的状态
  // 视频播放异常反馈
  useEffect(() => {
    if (videoId && video[videoId] && !video[videoId].loading && !video[videoId].videoUrl) {
      message.error({
        duration: 3,
        content: '视频播放出错啦!',
        icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
      });
    }
  }, [video]);
  const handleRequestVideoUrl = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    if (countRef.current > 100 || !video[videoId] || !video[videoId].videoUrl) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onVideoError && onVideoError();
    dispatch(
      getVideoContent({
        videoId,
      }),
    );
  };
  useEffect(() => {
    if (player) {
      player.subscribeToStateChange(e => {
        const { error, readyState, paused } = e;
        if (error) {
          handleRequestVideoUrl();
          setCount(state => state + 1);
        } else if (!error && readyState !== 0) {
          setCount(0);
        }
        setPause(paused);
      });
    }
  }, [player]);

  // const handelFull = e => {
  //   const {
  //     target: { className },
  //   } = e;
  //   if (busyRef.current) {
  //     handelFull(e);
  //     return;
  //   }
  //   if (className && className.indexOf('video-react-icon-fullscreen-exit') > -1) {
  //     setFullScreen(false);
  //     PCStoreJsBridge.wpExitMaximizeStroe().then(({ succ }) => {
  //       if (!succ) {
  //         handelFull(e);
  //       } else {
  //         setBusy(true);
  //       }
  //     });
  //     return;
  //   }
  //   if (className && className.indexOf('video-react-icon-fullscreen') > -1) {
  //     setFullScreen(true);
  //     PCStoreJsBridge.wpMaximizeStroe().then(({ succ }) => {
  //       if (!succ) {
  //         handelFull(e);
  //       } else {
  //         setBusy(true);
  //       }
  //     });
  //   }
  // };

  // const hanldeDbFull = () => {
  //   if (busyRef.current) {
  //     hanldeDbFull();
  //     return;
  //   }
  //   if (!fullScreen) {
  //     PCStoreJsBridge.wpMaximizeStroe().then(({ succ }) => {
  //       if (!succ) {
  //         hanldeDbFull();
  //       } else {
  //         setFullScreen(true);
  //       }
  //     });
  //   } else {
  //     PCStoreJsBridge.wpExitMaximizeStroe().then(({ succ }) => {
  //       if (!succ) {
  //         hanldeDbFull();
  //       } else {
  //         setFullScreen(false);
  //       }
  //     });
  //   }
  // };

  // useEffect(() => {
  //   const full = document.getElementsByClassName('video-react-fullscreen-control');
  //   if (full) {
  //     // eslint-disable-next-line no-plusplus
  //     for (let i = 0; i < full.length; i++) {
  //       full[i].addEventListener('click', handelFull);
  //     }
  //   }
  // }, [player]);
  // useEffect(() => {
  //   const full = document.getElementsByClassName('video-react-fullscreen-control');
  //   return () => {
  //     if (full) {
  //       // eslint-disable-next-line no-plusplus
  //       for (let i = 0; i < full.length; i++) {
  //         full[i].removeEventListener('click', handelFull);
  //       }
  //     }
  //   };
  // }, []);

  const hanldeRecordData = useCallback(() => {
    if (pause) {
      // 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Special_Video',
          label: '',
          param2: {
            source: source || logInfo.source || logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [pause]);

  // 视屏停止后显示海报
  useEffect(() => {
    if (pause && player) {
      const {
        player: { ended },
      } = player.getState();

      if (ended) {
        player.load();
      }
    }
  }, [pause, player]);

  const handelPlay = () => {
    if (!player) {
      return;
    }
    if (pause) {
      player.play();
    } else {
      player.pause();
    }
  };
  return (
    <div
      className={styles.VideoPreview}
      style={{
        width: `${width}px`,
        // eslint-disable-next-line no-nested-ternary
        height: `${height}px`,
        boxSizing: 'border-box',
      }}
      onClick={hanldeRecordData}
      // onDoubleClick={hanldeDbFull}
    >
      <Player
        src={`${videoId && video[videoId] && video[videoId].videoUrl}`}
        poster={imgUrl}
        ref={r => setPlayer(r)}
        className={styles.player}
        fluid={false}
        height={height}
        width={width}
        preload="auto"
        loop={loop}
        muted
        // onDoubleClick={hanldeDbFull}
        name="media"
        playsInline
      >
        <Shortcut dblclickable={false} shortcuts={shortcuts} clickable={false} />
        <BigPlayButton position="center" className={styles.player_btn} />
        <ControlBar
          autoHide
          disableCompletely={disableDefaultControls}
          className={styles.ControlBar}
        >
          <PlaybackRateMenuButton
            rates={[0.5, '1.0', 1.25, 1.5, '2.0']}
            className={classNames(
              styles.beishu,
              fullScreen ? styles.beishu_large : styles.beishu_small,
              styles[`beishu_small-${height - 24}`],
            )}
          />
        </ControlBar>
      </Player>
      <div
        className={`iconfont ${!pause ? 'icon-v_play' : 'icon-v_stop'} ${styles.detail_video_btn} ${
          pause ? styles.detail_video_btn_show : ''
        }`}
        onClick={handelPlay}
      />
    </div>
  );
};

export default Video;
